import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="container mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>
      <p className="mb-4">Last updated: November 18, 2025</p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
        <p className="mb-2">
          Welcome to RE-loop. These Terms and Conditions govern your use of our website and services. By accessing or using our service, you agree to be bound by these terms.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">2. About Us</h2>
        <p className="mb-2">
          RE-loop is a registered business in India, providing a marketplace for pre-owned electronics. Our platform connects buyers and sellers, promoting sustainability and accessibility in technology.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">3. User Responsibilities</h2>
        <p className="mb-2">
          You agree to provide accurate and complete information when creating an account and making transactions. You are responsible for maintaining the confidentiality of your account and password.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">4. Shipping Policy</h2>
        <p className="mb-2">
          All orders are processed within 1-2 business days. Shipping times vary based on your location and the shipping method selected at checkout.
          Standard shipping typically takes 5-7 business days. You will receive a tracking number via email once your order has been dispatched.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">5. Refund and Replacement Policy</h2>
        <h3 className="text-xl font-medium mb-2">5.1. Eligibility</h3>
        <p className="mb-2">
          We offer refunds or replacements for products that are defective, damaged, or if you receive the wrong item. You must notify us within 7 days of receiving your order. The item must be unused and in its original packaging.
        </p>
        <h3 className="text-xl font-medium mb-2">5.2. Process</h3>
        <p className="mb-2">
          To initiate a refund or replacement, contact us at support@reloop.com with your order number and a description of the issue.
        </p>
        <h3 className="text-xl font-medium mb-2">5.3. Refund Time</h3>
        <p className="mb-2">
          Approved refunds will be processed within 5-10 business days to your original method of payment.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">6. Payment Gateways</h2>
        <p className="mb-2">
          We use third-party payment gateways, including PhonePe, to process transactions. We are not responsible for the performance or security of these gateways. Your use of these services is subject to their terms and conditions.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">7. Intellectual Property</h2>
        <p className="mb-2">
          All content on this website, including text, graphics, logos, and images, is the property of RE-loop and is protected by copyright laws.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">8. Limitation of Liability</h2>
        <p className="mb-2">
          RE-loop is not liable for any indirect, incidental, or consequential damages arising from your use of our services.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">9. Governing Law</h2>
        <p className="mb-2">
          These Terms and Conditions are governed by the laws of India.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">10. Changes to Terms and Conditions</h2>
        <p className="mb-2">
          We reserve the right to update these Terms and Conditions at any time. Your continued use of the website following any changes constitutes acceptance of those changes.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">11. Contact Information</h2>
        <p>
          If you have any questions about these Terms and Conditions, please contact us at:
          <br />
          Email: support@reloop.com
          <br />
          Address: [Your Business Address Here]
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;